module.exports = window.ctEvents;